import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FichaCadastro } from '../../ficha-cadastro';
import { Veiculo } from '../../model/veiculo';
import { FichaCadastroTipo } from './../../ficha-cadastro-tipo';

@Component({
  selector: 'app-ficha-cadastro-veiculo-card',
  templateUrl: './ficha-cadastro-veiculo-card.component.html',
  styleUrls: ['./ficha-cadastro-veiculo-card.component.scss'],
})
export class FichaCadastroVeiculoCardComponent implements OnInit {
  @Input() index: number;
  @Input() veiculo: Veiculo;
  @Input() veiculos: Veiculo[];
  @Output() remover: EventEmitter<void> = new EventEmitter();
  @Output() editar: EventEmitter<boolean> = new EventEmitter();
  @Input() hasIdSimulacao: boolean;
  @Input() fichaCadastro: FichaCadastro;

  public fichaCadastroTipo = FichaCadastroTipo;

  private estados = {
    AC: 'AC - Acre',
    AL: 'AL - Alagoas',
    AP: 'AP - Amapá',
    AM: 'AM - Amazonas',
    BA: 'BA - Bahia',
    CE: 'CE - Ceará',
    DF: 'DF - Distrito Federal',
    ES: 'ES - Espírito Santo',
    GO: 'GO - Goiás',
    MA: 'MA - Maranhão',
    MT: 'MT - Mato Grosso',
    MS: 'MS - Mato Grosso do Sul',
    MG: 'MG - Minas Gerais',
    PA: 'PA - Pará',
    PB: 'PB - Paraíba',
    PR: 'PR - Paraná',
    PE: 'PE - Pernambuco',
    PI: 'PI - Piauí',
    RJ: 'RJ - Rio de Janeiro',
    RN: 'RN - Rio Grande do Norte',
    RS: 'RS - Rio Grande do Sul',
    RO: 'RO - Rondônia',
    RR: 'RR - Roraima',
    SC: 'SC - Santa Catarina',
    SP: 'SP - São Paulo',
    SE: 'SE - Sergipe',
    TO: 'TO - Tocantins',
  };

  constructor() { }

  ngOnInit() {}

  public onClickRemove(): void {
    this.remover.emit();
  }

  public onClickEdit(isInformarManualmente?): void {
    this.editar.emit(isInformarManualmente || false);
  }

  public get hasAnyEdit(): boolean {
    return this.veiculos.some((v) => v.isEdit);
  }

  public get estadoLicenciamento(): string {
    return this.estados[this.veiculo.ufLicenciamento];
  }

  public get isZeroKm(): boolean {
    return this.veiculo.isZeroKm;
  }

  public get descricao(): string {
    const {
      veiculoMarca,
      veiculoModelo,
      veiculoVersao,
      veiculoAno,
      veiculoCombustivel,
    } = this.veiculo;

    return `${(veiculoMarca && veiculoMarca.descricao) || ''} ${(veiculoModelo && veiculoModelo.descricao) || ''
      } ${(veiculoVersao && veiculoVersao.descricao) || ''
      } ${veiculoAno} ${veiculoCombustivel}`;
  }

  public get title(): string {
    if (!this.index) {
      return 'Informações do veículo principal';
    }

    return 'Informações do veículo';
  }

  public get hasPendencia(): boolean {
    return !!this.veiculo.pendencia;
  }

  public get descricaoPendencia(): string {
    if (!this.veiculo || !this.veiculo.pendencia) {
      return null;
    }
    switch (this.veiculo.pendencia.error) {
      case 'PLACA_INVALIDA':
        return 'Placa inválida';
      case 'FIPE_NOT_FOUND':
        return 'Fipe não encontrada';
      case 'GARANTIA_RECUSADA':
        return 'Garantia recusada';
    }
    return '';
  }

  public get isGaratiaRecusada(): boolean {
    if (!this.veiculo || !this.veiculo.pendencia) {
      return false;
    }

    return this.veiculo.pendencia.error === 'GARANTIA_RECUSADA';
  }
}
